const NutrientLoading = () => {
  const NutrientLoadingData = [
    {
      "Source": "Cherry Creek (CC-10)",
      "Phosphorus Mass (pounds)": Number(8187).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(63638).toLocaleString(),
    },
    {
      "Source": "Cottonwood Creek (CT-2)",
      "Phosphorus Mass (pounds)": Number(539).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(13358).toLocaleString(),
    },
    {
      "Source": "Alluvial Groundwater",
      "Phosphorus Mass (pounds)": Number(1137).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(1885).toLocaleString(),
    },
    {
      "Source": "Precipitation",
      "Phosphorus Mass (pounds)": Number(281).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(3637).toLocaleString(),
    },
    {
      "Source": "Total",
      "Phosphorus Mass (pounds)": Number(10144).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(82518).toLocaleString(),
    }
  ];

   // Declare and configure request overview table
   const NutrientLoadingTable = new requestTable({
    container: "#nutrient-loading-table",
    filterEnabled: false,
    tableHeaders: {
      "Source": "Source",
      "Phosphorus Mass (pounds)": "Phosphorus Mass (pounds)",
      "Nitrogen Mass (pounds)": "Nitrogen Mass (pounds)",
    },
    tableActions: [],
    tableData: NutrientLoadingData,
  });
  NutrientLoadingTable.buildTable();
};
